import { DEFAULT_LOCALE } from '@ghostscreen/contracts';
import { ApiRequestError } from '../lib/api';
import { i18n } from './i18n';

const KNOWN_CODES = ['bad_request', 'unauthorized', 'forbidden', 'not_found', 'conflict'] as const;
type KnownCode = (typeof KNOWN_CODES)[number];

function isKnownCode(code: string | undefined): code is KnownCode {
  return KNOWN_CODES.includes(code as KnownCode);
}

/**
 * User-facing text for a failed API call. API messages are written in English,
 * so other languages get a translated message for the error code instead.
 * `fallback` must already be translated.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  if (!(error instanceof ApiRequestError)) return fallback;
  if (i18n.resolvedLanguage === DEFAULT_LOCALE) return error.message || fallback;
  return isKnownCode(error.code) ? i18n.t(`common:apiErrors.${error.code}`) : fallback;
}
